import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'declaration', pathMatch: 'full' },
  {
    path: 'declaration',
    loadComponent: () =>
      import('./features/declaration/declaration-wizard.component').then(
        (m) => m.DeclarationWizardComponent
      ),
  },
  {
    path: 'confirmation/:declarationNo',
    loadComponent: () =>
      import('./features/confirmation/confirmation.component').then(
        (m) => m.ConfirmationComponent
      ),
  },
];
